const $ = require('jquery')

const { BREAKPOINT } = require('./api')

// =========================================================================
// Module: Grid Tiles
// =========================================================================
const gridTiles = {
  init () {
    $('.grid-tiles .grid').masonry({ itemSelector: '.grid-item' })
    $('.grid-item__main-content .grid-item__headline .main-headline > h3, .grid-item__main-content .grid-item__headline .main-headline > h4').ellipsis({ live: true })
    $('.grid-item__headline .main-headline--hover').ellipsis({ live: true })
  },

  responsive () {
    $('.grid-tiles').each(function() {
      const _ = $(this).find('.grid')

      if (!_.hasClass('slick-initialized') && window.innerWidth <= BREAKPOINT.TABLET) {
        _.masonry('destroy')
        _.slick({ arrows: false })
        _.find('.slick-track').css('margin-left', '30px')
        _.on('afterChange', function() {
          $(this).find('.slick-track').css('margin-left', '0')
        })
      } else if (_.hasClass('slick-initialized') && window.innerWidth > BREAKPOINT.TABLET) {
        _.slick('unslick')
        _.masonry({ itemSelector: '.grid-item' })
      }
    })
  },
}

module.exports = gridTiles



// WEBPACK FOOTER //
// ./src/modules/gridTiles.js